export enum ROLE_NAME {
   CUSTOMER_ADMINISTRATOR = 'Customer Administrator (User Management)'
}